module.exports = __webpack_public_path__ + "img/Gcc-Blue.e599cd71.png";